(() => {
  function init(scope) {
    scope.querySelectorAll('[data-sa-collection]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const grid = root.querySelector('[data-sa-c-grid]');
      const cards = Array.from(grid.querySelectorAll('[data-sa-c-card]'));
      const style = root.querySelector('[data-sa-c-style]');
      const color = root.querySelector('[data-sa-c-color]');
      const sort = root.querySelector('[data-sa-c-sort]');
      const labels = {gothic:'Gothic & dark',romantic:'Romantic & playful',woodland:'Woodland',iridescent:'Metallic details',vintage:'Vintage'};
      const styles = [...new Set(cards.flatMap(c => (c.dataset.styles || '').split(' ').filter(s => labels[s])))];
      const styleNav = root.querySelector('[data-sa-c-style-nav]');
      const colors = [...new Set(cards.map(c => c.dataset.color).filter(Boolean))];
      styles.forEach(value => style.add(new Option(labels[value], value)));
      colors.forEach(value => color.add(new Option(value[0].toUpperCase() + value.slice(1), value)));
      const initialQuery = new URL(location.href).searchParams;
      const queryStyle = initialQuery.get('style');
      if (queryStyle && labels[queryStyle]) {
        if (!styles.includes(queryStyle)) style.add(new Option(labels[queryStyle], queryStyle));
        style.value = queryStyle;
      }
      if (colors.includes(initialQuery.get('color'))) color.value = initialQuery.get('color');
      if (initialQuery.get('sort') === 'title') sort.value = 'title';
      const controls = root.querySelector('[data-sa-c-controls]');
      controls.hidden = cards.length === 0;
      if (styleNav) {
        style.closest('label').hidden = true;
        const base = styleNav.querySelector('[data-sa-c-style-link="all"]').href;
        Object.keys(labels).filter(value => styles.includes(value) || value === queryStyle).forEach(value => {
          const link = document.createElement('a');
          const url = new URL(base);
          url.searchParams.set('style', value);
          link.href = url.href;
          link.dataset.saCStyleLink = value;
          link.textContent = labels[value];
          styleNav.append(link);
        });
      }
      if (cards.length < 2) {
        sort.closest('label').hidden = true;
        if (!queryStyle) {style.closest('label').hidden = true; color.closest('label').hidden = true;}
      }
      let previousSort = 'featured';
      function update() {
        const ordered = sort.value === 'title' ? [...cards].sort((a,b) => a.dataset.title.localeCompare(b.dataset.title)) : cards;
        if (sort.value !== previousSort) {
          ordered.forEach(card => grid.append(card));
          previousSort = sort.value;
        }
        let count = 0;
        cards.forEach(card => {
          card.hidden = !(style.value === 'all' || (card.dataset.styles || '').split(' ').includes(style.value)) || !(color.value === 'all' || card.dataset.color === color.value);
          if (!card.hidden) count++;
        });
        root.querySelector('[data-sa-c-count]').textContent = `${count} ${count === 1 ? 'piece' : 'pieces'}`;
        root.querySelector('[data-sa-c-empty]').hidden = count !== 0;
        const filtered = style.value !== 'all' || color.value !== 'all';
        root.querySelector('.sa-c-clear').hidden = !filtered;
        styleNav?.querySelectorAll('[data-sa-c-style-link]').forEach(link => {
          if (link.dataset.saCStyleLink === style.value) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
      }
      function syncStyleUrl(push = false) {
        const url = new URL(location.href);
        if (style.value === 'all') url.searchParams.delete('style');
        else url.searchParams.set('style', style.value);
        if (color.value === 'all') url.searchParams.delete('color');
        else url.searchParams.set('color', color.value);
        if (sort.value === 'featured') url.searchParams.delete('sort');
        else url.searchParams.set('sort', sort.value);
        if (url.href !== location.href) history[push ? 'pushState' : 'replaceState'](null, '', url);
      }
      styleNav?.addEventListener('click', e => {
        const link = e.target.closest('[data-sa-c-style-link]');
        if (!link || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        style.value = link.dataset.saCStyleLink;
        if (style.value === 'all') color.value = 'all';
        update();
        syncStyleUrl(true);
      });
      window.addEventListener('popstate', () => {
        const query = new URL(location.href).searchParams;
        const value = query.get('style');
        style.value = labels[value] ? value : 'all';
        color.value = colors.includes(query.get('color')) ? query.get('color') : 'all';
        sort.value = query.get('sort') === 'title' ? 'title' : 'featured';
        update();
      });
      [style,color,sort].forEach(el => el.addEventListener('change', () => {update();syncStyleUrl();}));
      root.querySelectorAll('[data-sa-c-reset]').forEach(button => button.addEventListener('click', () => {style.value='all';color.value='all';sort.value='featured';update();syncStyleUrl();}));
      root.addEventListener('click', e => {
        const opener = e.target.closest('[data-sa-c-open]');
        if (!opener) return;
        const dialog = document.getElementById(opener.dataset.saCOpen);
        if (!dialog) return;
        dialog.returnFocus = opener;
        dialog.showModal();
      });
      root.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => dialog.returnFocus?.focus());
        dialog.addEventListener('click', e => {
          if (e.target !== dialog) return;
          const r=dialog.getBoundingClientRect();
          if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();
        });
      });
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
